<script>
import TableContent from '@/components/ui/Table/components/TableContent.vue';
import TableHeader from '@/components/ui/Table/components/TableHeader.vue';
import TablePaginate from '@/components/ui/Table/components/TablePaginate.vue';

export default {
    name: 'BaseTable',
    components: {TablePaginate, TableContent, TableHeader},
    props: {
        multiselect: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        title: String,
        headers: {
            type: Object,
            default: function () {
                return {};
            }
        },
        data: {
            type: Array,
            default: function () {
                return [];
            }
        },
        page: Number,
        lastPage: Number,
    },
    methods: {
      selectionChange(event) {
        this.$emit('update:selected', event)
      }
    }
}
</script>

<template>
<div class="base-table">
    <TableHeader v-if="title" :title="title">
    </TableHeader>
    <TableHeader v-else-if="$slots['header-content']">
        <slot name="header-content"></slot>
    </TableHeader>
    <TableContent :headers="headers" :data="data" :multiselect="multiselect" @update:selected="selectionChange">
        <template v-for="name in Object.keys($scopedSlots)" v-slot:[name]="slotProps">
            <slot :name="name" v-bind="slotProps" />
        </template>
    </TableContent>
    <TablePaginate v-if="page && lastPage" :page="page" :last-page="lastPage" @change-page="$emit('change-page', $event)" />
</div>
</template>

<style scoped lang="scss">
.base-table {
    /* Table */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    /* Base / White */
    background: #FFFFFF;
    /* Gray/200 */
    border: 1px solid #E9EAEB;
    /* Shadow/xs */
    box-shadow: 0 1px 2px rgba(10, 13, 18, 0.05);
    border-radius: 12px;
    overflow: hidden;
}
</style>
